import entidad01 from "./estados/entidad01";
import entidad02 from "./estados/entidad02";
import entidad03 from "./estados/entidad03";
import entidad04 from "./estados/entidad04";
import entidad05 from "./estados/entidad05";
import entidad06 from "./estados/entidad06";
import entidad07 from "./estados/entidad07";
import entidad08 from "./estados/entidad08";
import entidad09 from "./estados/entidad09";
import entidad10 from "./estados/entidad10";
import entidad11 from "./estados/entidad11";
import entidad12 from "./estados/entidad12";
import entidad13 from "./estados/entidad13";
import entidad14 from "./estados/entidad14";
import entidad15 from "./estados/entidad15";
import entidad16 from "./estados/entidad16";
import entidad17 from "./estados/entidad17";
import entidad18 from "./estados/entidad18";
import entidad19 from "./estados/entidad19";
import entidad20 from "./estados/entidad20";
import entidad21 from "./estados/entidad21";
import entidad22 from "./estados/entidad22";
import entidad23 from "./estados/entidad23";
import entidad24 from "./estados/entidad24";
import entidad25 from "./estados/entidad25";
import entidad26 from "./estados/entidad26";
import entidad27 from "./estados/entidad27";
import entidad28 from "./estados/entidad28";
import entidad29 from "./estados/entidad29";
import entidad30 from "./estados/entidad30";
import entidad31 from "./estados/entidad31";
import entidad32 from "./estados/entidad32";

export const mapas = [
    {
        id: 1,
        mapa: entidad01
    },
    {
        id: 2,
        mapa: entidad02
    },
    {
        id: 3,
        mapa: entidad03
    },
    {
        id: 4,
        mapa: entidad04
    },
    {
        id: 5,
        mapa: entidad05
    },
    {
        id: 6,
        mapa: entidad06
    },
    {
        id: 7,
        mapa: entidad07
    },
    {
        id: 8,
        mapa: entidad08
    },
    {
        id: 9,
        mapa: entidad09
    },
    {
        id: 10,
        mapa: entidad10
    },
    {
        id: 11,
        mapa: entidad11
    },
    {
        id: 12,
        mapa: entidad12
    },
    {
        id: 13,
        mapa: entidad13
    },
    {
        id: 14,
        mapa: entidad14
    },
    {
        id: 15,
        mapa: entidad15
    },
    {
        id: 16,
        mapa: entidad16
    },
    {
        id: 17,
        mapa: entidad17
    },
    {
        id: 18,
        mapa: entidad18
    },
    {
        id: 19,
        mapa: entidad19
    },
    {
        id: 20,
        mapa: entidad20
    },
    {
        id: 21,
        mapa: entidad21
    },
    {
        id: 22,
        mapa: entidad22
    },
    {
        id: 23,
        mapa: entidad23
    },
    {
        id: 24,
        mapa: entidad24
    },
    {
        id: 25,
        mapa: entidad25
    },
    {
        id: 26,
        mapa: entidad26
    },
    {
        id: 27,
        mapa: entidad27
    },
    {
        id: 28,
        mapa: entidad28
    },
    {
        id: 29,
        mapa: entidad29
    },
    {
        id: 30,
        mapa: entidad30
    },
    {
        id: 31,
        mapa: entidad31
    },
    {
        id: 32,
        mapa: entidad32
    },
]